import styled from 'styled-components';
import Image from 'next/legacy/image';
import { useRouter } from 'next/router';
import i18n from 'utils/i18n';

export type CertificateItemProps = {
  certificate: Certificate;
  checked?: boolean;
  status?: AssessmentStatus | null;
};

export const CertificateItem: React.FC<CertificateItemProps> = ({ certificate }) => {
  const { locale } = useRouter();
  const { dictionary } = i18n[(locale as AcceptedLocales) || 'en-US'];
  
  return (
    <StyledCertificateItem className="certificate">
      <div className="inner-cert">
        <div className="badge">
          {certificate.badge ? (
            <div className="header-icon">
              <Image
                src={certificate.badge.url}
                width={certificate.badge.width}
                height={certificate.badge.height}
                alt={certificate.badge.title}
                sizes="48px"
                quality={100}
              />
            </div>
          ) : (
            <div className="empty-header-icon"></div>
          )}
        </div>

        <div className="info">
          <div className="subtitle">{dictionary.certificate}</div>
          <h3>{certificate.name}</h3>
          {/* <div className="description">Something here?</div> */}
        </div>
      </div>
    </StyledCertificateItem>
  );
};

export const StyledCertificateItem = styled.div`
  margin: 2rem 0;

  h2 {
    margin: 1.5rem 0;
  }

  .certificate-text {
    margin: 1.5rem 0;

    p + p {
      margin-top: 0.75rem;
    }
  }

  .inner-cert {
    padding: 0.5rem 0;
    display: flex;
    position: relative;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
  }

  .badge {
    width: 48px;

    .empty-header-icon {
      width: 48px;
      height: 48px;
      background: #52b3c0;
      border: 3px solid #438c94;
      border-radius: 50%;
    }
  }

  h3 {
    margin: 0;
  }
`;

export default CertificateItem;
